module.exports = __webpack_public_path__ + "static/logo2-9d87b0242fc09bafd789b55af68daff4.png";